<script lang="ts">
	import { onDestroy } from 'svelte';
	import { MCP_SERVER_NAME, MCP_URL } from '$lib/siteConfig';

	let {
		compact = false,
		blendDarkBackground = false,
		pageBackground = false,
		showInstructions = false
	}: {
		compact?: boolean;
		blendDarkBackground?: boolean;
		pageBackground?: boolean;
		showInstructions?: boolean;
	} = $props();

	const commands: { instruction: string; command: string }[] = [
		{
			instruction: 'For Claude Code, run:',
			command: `claude mcp add -t http ${MCP_SERVER_NAME} ${MCP_URL}`
		},
		{
			instruction: 'For Codex, run:',
			command: `codex mcp add ${MCP_SERVER_NAME} --url ${MCP_URL}`
		}
	];
	let copiedCommand: string | null = $state(null);
	let copiedTimeout: ReturnType<typeof setTimeout> | undefined;

	function copyCommand(command: string): void {
		void navigator.clipboard?.writeText(command);
		copiedCommand = command;
		clearTimeout(copiedTimeout);
		copiedTimeout = setTimeout(() => (copiedCommand = null), 1200);
	}

	onDestroy(() => clearTimeout(copiedTimeout));
</script>

<div
	class="flex flex-col gap-2"
	class:compact
	class:landing-spacing={pageBackground}
	class:instruction-spacing={showInstructions}
>
	{#each commands as item}
		<div>
			{#if showInstructions}
				<p class="mb-2 text-base leading-7 text-zinc-700 dark:text-zinc-300">
					{item.instruction}
				</p>
			{/if}
			<div
				class="flex min-w-0 flex-1 items-center gap-1 rounded border border-zinc-200 bg-zinc-100 py-1.5 pl-2 pr-1 dark:border-zinc-800 dark:bg-zinc-900"
				class:blend-dark-background={blendDarkBackground}
				class:page-background={pageBackground}
			>
				<code
					class="command-text command-scroll min-w-0 flex-1 overflow-x-auto whitespace-nowrap text-zinc-700 dark:text-zinc-200"
					><span class="font-semibold text-cyan-700 dark:text-cyan-400"
						>{item.command.split(' ')[0]}</span
					>{item.command.slice(item.command.split(' ')[0].length)}</code
				>
				<button
					type="button"
					aria-label="Copy command"
					class="copy-button shrink-0 text-center text-zinc-400 hover:text-zinc-600 dark:text-zinc-500 dark:hover:text-zinc-300"
					onclick={() => copyCommand(item.command)}
				>
					<i class={copiedCommand === item.command ? 'fa-solid fa-check' : 'fa-regular fa-copy'}
					></i>
				</button>
			</div>
		</div>
	{/each}
</div>

<style>
	.command-text {
		font-size: 16px;
		line-height: 25px;
	}
	.compact .command-text {
		font-size: 10px;
		line-height: 1.5;
	}
	.copy-button {
		width: 28px;
		font-size: 14px;
	}
	.compact .copy-button {
		width: 20px;
		font-size: 10px;
	}
	.landing-spacing {
		gap: 12px;
	}
	.instruction-spacing {
		gap: 16px;
	}
	:global(.dark) .blend-dark-background {
		background-color: transparent;
	}
	.page-background {
		background-color: #fff;
	}
	:global(.dark) .page-background {
		background-color: #000;
	}
	.command-scroll {
		scrollbar-width: none;
	}
	.command-scroll::-webkit-scrollbar {
		display: none;
	}
</style>
